<div class="stepper">
    <ul>
        @for(step of stepperContent; track step.stepId){
            <li class="title"  (click)="goToStep(step.stepId)" [ngClass]="(currentStepper == step.stepId || isEditable) ? 'current' : 'previous'">
                <div class="img-sec">
                    <img [src]="'../../../assets/images/' + step.iconName" />
                </div>
                <div class="content-sec">
                    <div class="ct-1">STEP {{step.stepId}}</div>
                    <div class="ct-2">{{step.title}}</div>
                </div>
            </li>
        }
    </ul>
</div>